/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {fetchData, toasterrormsg, toastsuccessmsg} from '../../../../reusable'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import { useIntl } from 'react-intl'
import {  Tr } from '../../../../_metronic/i18n/Tr'


/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
   let t = Tr()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [error, setError] = useState({email: '', password: ''})
  const [datapost, setDatapost] = useState(false)
  const [passwordDisplay, setPasswordDisplay] = useState(false)
  const intl = useIntl()

  const validate = (submited: any = false) => {
    setDatapost(true)
    var tmpErr = error
    if (email == '' || email == null) {
      tmpErr['email'] = t("Email Is Required")
    } else {
      tmpErr['email'] = ''
    }
    if (password == '' || password == null) {
      tmpErr['password'] = t("Password Is Requried")
    } else {
      tmpErr['password'] = ''
    }

    if (tmpErr['email'] == '' && tmpErr['password'] == '' && submited == true) {
      loginapicall()
    }
  }

  const loginapicall = async () => {
    var param: any = {
      email: email,
      password: password,
    }

    var response: any = await fetchData('admin/login', param)
    
    if (response.status == '200') {
      var data = response.data[0]
      var arr = {
        adminId: data.adminId,
        email: data.email,
        mobileNumber: data.mobileNumber,
        profilePicture: data.profilePicture,
        fullName: data.fullName,
        roleId: data.roleId,
        mainadminId: data.mainadminId,
      }

      sessionStorage.setItem('admin', JSON.stringify(arr))
      toastsuccessmsg('Login Successfully')
      window.location.reload()
    } else {
      setLoading(false)
      toasterrormsg(response.message)
    }
  }

 

  return (
    <>
      <ToastContainer />
      <div className='bg-body d-flex justify-content-center rounded-4 w-md-600px pt-10 p-10'>
        <div className='h-lg-100 w-md-400px'>
          <div className='form w-100' id='kt_login_signin_form'>
            {/* begin::Heading */}
            <div className='text-center mb-11'>
              <h1 className='text-dark fw-bolder mb-3'>{t("Sign In")}</h1>
            </div>
            {/* begin::Heading */}

            {/* begin::Form group */}
            <div className='fv-row mb-8'>
              <label className='form-label fs-6 fw-bolder text-dark'>{t("Email")}</label>
              <input
                placeholder={t("Email")}
                className='form-control bg-transparent'
                type='email'
                name='email'
                autoComplete='off'
                onChange={(e: any) => {
                  setEmail(e.target.value)
                  if (datapost == true) {
                    validate()
                  }
                }}
                onKeyDown={(e: any) => {
                  if (
                    (e.key === 'Enter' || e.keyCode === 13) &&
                    email != '' &&
                    email != null &&
                    password != '' &&
                    password != null
                  ) {
                    validate(true)
                  }
                }}
              />
              {error['email'] != '' && <span className='text-danger'>{error['email']}</span>}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='fv-row mb-3' style={{position: 'relative'}}>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>{t("Password")}</label>
              <div style={{position: 'relative'}}>
                <input
                  type={passwordDisplay == true ? 'text' : 'password'}
                  autoComplete='off'
                  placeholder={t("Password")}
                  className='form-control bg-transparent'
                  onChange={(e: any) => {
                    setPassword(e.target.value)
                    if (datapost == true) {
                      validate()
                    }
                  }}
                  onKeyDown={(e: any) => {
                    if (
                      (e.key === 'Enter' || e.keyCode === 13) &&
                      email != '' &&
                      email != null &&
                      password != '' &&
                      password != null
                    ) {
                      validate(true)
                    }
                  }}
                />
                <span
                  className='cursor-pointer'
                  style={{position: 'absolute', top: '25%', right: '20px'}}
                  title={passwordDisplay == true ? 'Hide' : 'Show'}
                  onClick={() => setPasswordDisplay(!passwordDisplay)}
                >
                  <FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} />
                </span>
                <div className='fv-plugins-message-container invalid-feedback'></div>
              </div>
              {error['password'] != '' && <span className='text-danger'>{error['password']}</span>}
            </div>
            {/* end::Form group */}

            {/* begin::Wrapper */}
            <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
              <div />

              {/* begin::Link */}
              <Link to='#' className='link-success themeGreenColor'>
              {t("Forgot Password ?")}
              </Link>
              {/* end::Link */}
            </div>
            {/* end::Wrapper */}

            {/* begin::Action */}
            <div className='d-grid mb-10'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-success monthDiv'
                disabled={
                  email != '' && email != null && password != '' && password != null ? false : true
                }
                onClick={() => validate(true)}
              >
                {!loading && <span className='indicator-label'>{t("Continue")}</span>}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {t("Please wait...")}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Action */}
          </div>
        </div>
      </div>
    </>
  )
}
